import React from 'react';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Section } from '~/eds/src/components/Section/Section';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { useIntl } from 'react-intl';

import CrmIntegrationCardList from './CrmIntegrationCardList';
import DocumentEditingIntegrationCardList from './DocumentEditingIntegrationCardList';
import EsignatureIntegrationCardList from './EsignatureIntegrationCardList';
import ProcurementIntegrationCardList from './ProcurementIntegrationCardList';
import StorageIntegrationCardList from './StorageIntegrationCardList';

function AllIntegrations() {
  const aribaIntegration = useFlag(FlagType.AribaControllerFlag);
  const enableSharepointIntegration = useFlag(FlagType.SharepointWizard);

  const intl = useIntl();

  const providers = [
    {
      title: intl.formatMessage({
        id: 'AllIntegrations.electronicSignatures',
        defaultMessage: 'Electronic Signatures',
        description: 'Title for Electronic Signatures integrations section',
      }),
      component: <EsignatureIntegrationCardList />,
    },
    {
      title: intl.formatMessage({
        id: 'AllIntegrations.salesCrm',
        defaultMessage: 'Sales / CRM',
        description: 'Title for Sales and CRM integrations section',
      }),
      component: <CrmIntegrationCardList />,
    },
    {
      title: intl.formatMessage({
        id: 'AllIntegrations.storage',
        defaultMessage: 'Storage',
        description: 'Title for Storage integrations section',
      }),
      component: <StorageIntegrationCardList />,
    },
  ];

  if (enableSharepointIntegration) {
    providers.push({
      title: intl.formatMessage({
        id: 'AllIntegrations.documentEditing',
        defaultMessage: 'Document Editing',
        description: 'Title for Document Editing integrations section',
      }),
      component: <DocumentEditingIntegrationCardList />,
    });
  }

  if (aribaIntegration) {
    providers.push({
      title: intl.formatMessage({
        id: 'AllIntegrations.procurement',
        defaultMessage: 'Procurement',
        description: 'Title for Procurement integrations section',
      }),
      component: <ProcurementIntegrationCardList />,
    });
  }

  return (
    <Layout preset="sections">
      {providers.map((provider) => (
        <Section
          children={provider.component}
          key={provider.title}
          title={provider.title}
        />
      ))}
    </Layout>
  );
}
export default AllIntegrations;
